// Library imports
import React from "react";
import ReactDOM from "react-dom";

// Css import
import "./index.css";

// Component imports
import App from "./App";

// Other imports
import "./i18n";
import reportWebVitals from "./reportWebVitals";

// Render the application
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
